import * as React from "react";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";
import { Button } from "@mui/material";
import { useTranslation } from "react-i18next";


const style = (isMobile) => ({
  
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: isMobile ? "80%" : 550,
  bgcolor: "background.paper",
  boxShadow: 24,
  padding: isMobile ? "10px" : "40px",
  textAlign: "center",
});

export default function DeleteConfirmModal({ open, setOpen, handleReset }) {
  const handleClose = () => setOpen(false);
  const { t } = useTranslation();
  
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  
  return (
    <div>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style(isMobile)}>
          <h1>
            {t('deleteModal.title')}
          </h1>
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
              gap: "10px",
            }}
          >
            <Button
              onClick={() => setOpen(false)}
              variant="outlined"
              color="error"
              sx={{
               ...theme.components.MuiButton.styleOverrides.resetCancel,
                }}
              
            >
              {t('deleteModal.cancelButton')}
            </Button>
            <Button
              onClick={handleReset}
              variant="contained"
              color="error"
              sx={{
                ...theme.components.MuiButton.styleOverrides.resetConfirm,
                
              }}
            >
              {t('deleteModal.confirmButton')}
            </Button>
          </Box>
        </Box>
      </Modal>
    </div>
  );
}
